module.exports = __webpack_public_path__ + "img/plus.050906f1.svg";